import 'reset-css/sass/_reset.scss';
import 'swiper/css';
import 'swiper/css/effect-fade';

import './scss/main.scss';

import Swiper from 'swiper';
import { Autoplay, EffectFade } from 'swiper/modules';

import $ from 'jquery';

let scrollOptions: {
  speed: number;
  offset: number;
} = {
  speed: 200,
  offset: 20,
};

Swiper.use([Autoplay, EffectFade]);
const swiper = new Swiper('.swiper', {
  loop: true,
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
  speed: 1000,
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },
});

$(function () {
  $('.js-navbar').on('click', function () {
    $(this).toggleClass('is-active');
    $('#nav').slideToggle();
  });

  $('.js-accordion').on('click', function () {
    $(this).toggleClass('is-active');
    $(this).next().slideToggle();
  });

  $(window).on('load scroll', function () {
    let scr: number = window.pageYOffset;

    if (scr > 100) {
      $('.totop').fadeIn();
    } else {
      $('.totop').fadeOut();
    }
  });

  $('.popup-wrap').on('click', function () {
    $('#popup').fadeOut();
  });

  /**
   * オーナーズミーティング応募フォームのフォーム振り分け
   */

  if ($('#form-owner-pair-info').length) {
    const boatVal: string = '14ft';

    const sltrSelectOwnersBoatType: JQuery<HTMLElement> = $('select[name="boat-type"]');
    const sltrFormOwnerPair: JQuery<HTMLElement> = $('#form-owner-pair-info');

    const OwnersBoatType = sltrSelectOwnersBoatType.val();

    sltrFormOwnerPair.hide();

    sltrSelectOwnersBoatType.on('change', function () {
      if ($(this).val() === boatVal) {
        sltrFormOwnerPair.show();

        /**
         * 送信ボタンを一度「送信不可状態にする」
         */

        $('.wpcf7-submit').prop('disabled', true);
      } else {
        sltrFormOwnerPair.hide();
        $('.wpcf7-submit').prop('disabled', false);
      }
    });

    /**
     * 「同船者氏名」「同船者電話番号」両方が入力されている場合、送信不可状態を解除する
     */

    $('.owners-input-required').on('input', function () {
      let values: any[] = [];

      $('.owners-input-required').each(function () {
        values.push($(this).val());
      });

      /**
       * 同船者の入力がいずれか空になっている場合、trueを返す
       */
      let isValueEmpty = values.some(function (elm) {
        return elm === '';
      });

      if (isValueEmpty === false) {
        $('.wpcf7-submit').prop('disabled', false);
      } else {
        $('.wpcf7-submit').prop('disabled', true);
      }
    });
  }
});
